import React, { useState , useEffect} from 'react';

import './App.css';
import t1 from './thumbnails/1.jpg';
import t2 from './thumbnails/2.jpg';
import t3 from './thumbnails/3.jpg';
import t4 from './thumbnails/4.jpg';
import t5 from './thumbnails/5.jpg';
import t6 from './thumbnails/6.jpg';
import t7 from './thumbnails/7.jpg';
import t8 from './thumbnails/8.jpg';
import t9 from './thumbnails/9.jpg';
import t10 from './thumbnails/10.jpg';
import t11 from './thumbnails/11.jpg';
import t12 from './thumbnails/12.jpg';
import t13 from './thumbnails/13.jpg';
import t14 from './thumbnails/14.jpg';
import t15 from './thumbnails/15.jpg';
import t16 from './images16/r4ve_exported_image_20230826_203614.png';
import t17 from './thumbnails/17.jpg';
import t18 from './thumbnails/18.jpg';
import t19 from './thumbnails/19.jpg';
import i011 from './images1/1_1.jpg';
import i012 from './images1/1_2.jpg';
import i013 from './images1/1_3.jpg';
import i014 from './images1/1_4.jpg';
import i015 from './images1/1_5.jpg';
import i016 from './images1/1_6.jpg';
import i017 from './images1/1_7.jpg';
import i018 from './images1/1_8.jpg';
import i019 from './images1/1_9.jpg';
import i0110 from './images1/1_10.jpg';
import i0111 from './images1/1_11.jpg';
import i0112 from './images1/1_12.jpg';
import i0113 from './images1/1_13.jpg';
import i0114 from './images1/1_14.jpg';
// Import images from images2 folder
import i21 from './images2/2_1.jpg';
import i22 from './images2/2_2.jpg';
import i24 from './images2/2_4.jpg';
import i25 from './images2/2_5.jpg';
import i26 from './images2/2_6.jpg';
// Import images from images3 folder
import i31 from './images3/3_1.jpg';
import i32 from './images3/3_2.jpg';
import i33 from './images3/3_3.jpg';
import i34 from './images3/3_4.jpg';
// Import images from images4 folder
import i41 from './images4/4_1.jpg';
import i42 from './images4/4_2.jpg';
import i43 from './images4/4_3.jpg';
// Import images from images5 folder
import i51 from './images5/5_1.jpg';
import i52 from './images5/5_2.jpg';
import i53 from './images5/5_3.jpg';
import i54 from './images5/5_4.jpg';
// Import images from images6 folder
import i61 from './images6/6_1.jpg';
import i62 from './images6/6_2.jpg';
import i63 from './images6/6_3.jpg';
import i64 from './images6/6_4.jpg';
import i65 from './images6/6_5.jpg';
import i66 from './images6/6_6.jpg';
// Import images from images7 folder
import i71 from './images7/7_1.jpg';
import i72 from './images7/7_2.jpg';
import i73 from './images7/7_3.jpg';
import i74 from './images7/7_4.jpg';
import i75 from './images7/7_5.jpg';
import i76 from './images7/7_6.jpg';
import i77 from './images7/7_7.jpg';
import i78 from './images7/7_8.jpg';
import i79 from './images7/7_9.jpg';
import i710 from './images7/7_10.jpg';
import i711 from './images7/7_11.jpg';
import i712 from './images7/7_12.jpg';
import i713 from './images7/7_13.jpg';
import i714 from './images7/7_14.jpg';
import i715 from './images7/7_15.jpg';
import i716 from './images7/7_16.jpg';
import i717 from './images7/7_17.jpg';
import i718 from './images7/7_18.jpg';
import i719 from './images7/7_19.jpg';
import i720 from './images7/7_20.jpg';
import i721 from './images7/7_21.jpg';
import i722 from './images7/7_22.jpg';
import i723 from './images7/7_23.jpg';
import i724 from './images7/7_24.jpg';
import i725 from './images7/7_25.jpg';
import i726 from './images7/7_26.jpg';
import i727 from './images7/7_27.jpg';
import i728 from './images7/7_28.jpg';
import i729 from './images7/7_29.jpg';
import i731 from './images7/7_31.jpg';
import i732 from './images7/7_32.jpg';
import i733 from './images7/7_33.jpg';
import i734 from './images7/7_34.jpg';
import i735 from './images7/7_35.jpg';
import i736 from './images7/7_36.jpg';
import i737 from './images7/7_37.jpg';
import i738 from './images7/7_38.jpg';
import i739 from './images7/7_39.jpg';
import i740 from './images7/7_40.jpg';
import i81 from './images8/8_1.jpg';
import i82 from './images8/8_2.jpg';
import i83 from './images8/8_3.jpg';
import i84 from './images8/8_4.jpg';
import i85 from './images8/8_5.jpg';
import i86 from './images8/8_6.jpg';
import i87 from './images8/8_7.jpg';
import i88 from './images8/8_8.jpg';
import i89 from './images8/8_9.jpg';
import i810 from './images8/8_10.jpg';
import i811 from './images8/8_11.jpg';
import i812 from './images8/8_12.jpg';
import i813 from './images8/8_13.jpg';
import i814 from './images8/8_14.jpg';
import i815 from './images8/8_15.jpg';
import i816 from './images8/8_16.jpg';
import i817 from './images8/8_17.jpg';
import i818 from './images8/8_18.jpg';
import i819 from './images8/8_19.jpg';
import i820 from './images8/8_20.jpg';
import i821 from './images8/8_21.jpg';
import i822 from './images8/8_22.jpg';
import i823 from './images8/8_23.jpg';
import i824 from './images8/8_24.jpg';
import i825 from './images8/8_25.jpg';
import i826 from './images8/8_26.jpg';
import i827 from './images8/8_27.jpg';
import i828 from './images8/8_28.jpg';
import i829 from './images8/8_29.jpg';
import i830 from './images8/8_30.jpg';
import i831 from './images8/8_31.jpg';
import i832 from './images8/8_32.jpg';
import i833 from './images8/8_33.jpg';
import i834 from './images8/8_34.jpg';
import i835 from './images8/8_35.jpg';
import i836 from './images8/8_36.jpg';
import i837 from './images8/8_37.jpg';
import i838 from './images8/8_38.jpg';
import i839 from './images8/8_39.jpg';
import i840 from './images8/8_40.jpg';
import i841 from './images8/8_41.jpg';
import i842 from './images8/8_42.jpg';
import i843 from './images8/8_43.jpg';
import i844 from './images8/8_44.jpg';
import i845 from './images8/8_45.jpg';
import i846 from './images8/8_46.jpg';
import i847 from './images8/8_47.jpg';
import i848 from './images8/8_48.jpg';
import i849 from './images8/8_49.jpg';
import i850 from './images8/8_50.jpg';
import i851 from './images8/8_51.jpg';
import i852 from './images8/8_52.jpg';
import i853 from './images8/8_53.jpg';
import i854 from './images8/8_54.jpg';
import i855 from './images8/8_55.jpg';
import i856 from './images8/8_56.jpg';
import i857 from './images8/8_57.jpg';
import i858 from './images8/8_58.jpg';
import i859 from './images8/8_59.jpg';
import i860 from './images8/8_60.jpg';
import i861 from './images8/8_61.jpg';
import i862 from './images8/8_62.jpg';
import i863 from './images8/8_63.jpg';
import i864 from './images8/8_64.jpg';
import i865 from './images8/8_65.jpg';
import i866 from './images8/8_66.jpg';
import i867 from './images8/8_67.jpg';
import i868 from './images8/8_68.jpg';
import i869 from './images8/8_69.jpg';
import i870 from './images8/8_70.jpg';
import i871 from './images8/8_71.jpg';
import i872 from './images8/8_72.jpg';
import i873 from './images8/8_73.jpg';
import i874 from './images8/8_74.jpg';
import i875 from './images8/8_75.jpg';
import i876 from './images8/8_76.jpg';
import i877 from './images8/8_77.jpg';
import i878 from './images8/8_78.jpg';
import i879 from './images8/8_79.jpg';
import i880 from './images8/8_80.jpg';
import i881 from './images8/8_81.jpg';
import i882 from './images8/8_82.jpg';
import i883 from './images8/8_83.jpg';
import i884 from './images8/8_84.jpg';
import i885 from './images8/8_85.jpg';
import i886 from './images8/8_86.jpg';
import i887 from './images8/8_87.jpg';
import i888 from './images8/8_88.jpg';
import i889 from './images8/8_89.jpg';
import i890 from './images8/8_90.jpg';
import i891 from './images8/8_91.jpg';
import i892 from './images8/8_92.jpg';
import i893 from './images8/8_93.jpg';
import i894 from './images8/8_94.jpg';
import i895 from './images8/8_95.jpg';
import i896 from './images8/8_96.jpg';
import i897 from './images8/8_97.jpg';
import i898 from './images8/8_98.jpg';
import i899 from './images8/8_99.jpg';
import i8100 from './images8/8_100.jpg';
import i8101 from './images8/8_101.jpg';
import i8102 from './images8/8_102.jpg';
import i8103 from './images8/8_103.jpg';
import i8104 from './images8/8_104.jpg';
import i8105 from './images8/8_105.jpg';
import i8106 from './images8/8_106.jpg';
import i8107 from './images8/8_107.jpg';
import i8108 from './images8/8_108.jpg';
import i8109 from './images8/8_109.jpg';
import i8110 from './images8/8_110.jpg';
import i8111 from './images8/8_111.jpg';
import i8112 from './images8/8_112.jpg';
import i8113 from './images8/8_113.jpg';
import i8114 from './images8/8_114.jpg';
import i8115 from './images8/8_115.jpg';
import i8116 from './images8/8_116.jpg';
import i8117 from './images8/8_117.jpg';
import i8118 from './images8/8_118.jpg';
import i8119 from './images8/8_119.jpg';
import i8120 from './images8/8_120.jpg';
import i8121 from './images8/8_121.jpg';
import i8122 from './images8/8_122.jpg';
import i8123 from './images8/8_123.jpg';
import i8124 from './images8/8_124.jpg';
import i8125 from './images8/8_125.jpg';
import i8126 from './images8/8_126.jpg';
import i8127 from './images8/8_127.jpg';
import i8128 from './images8/8_128.jpg';
import i8129 from './images8/8_129.jpg';
import i8130 from './images8/8_130.jpg';
import i8131 from './images8/8_131.jpg';
import i8132 from './images8/8_132.jpg';
import i8133 from './images8/8_133.jpg';
import i8134 from './images8/8_134.jpg';
import i8135 from './images8/8_135.jpg';
import i8136 from './images8/8_136.jpg';
import i8137 from './images8/8_137.jpg';
import i8138 from './images8/8_138.jpg';
import i8139 from './images8/8_139.jpg';
import i8140 from './images8/8_140.jpg';
import i8141 from './images8/8_141.jpg';
import i8142 from './images8/8_142.jpg';
import i8143 from './images8/8_143.jpg';
import i8144 from './images8/8_144.jpg';
import i8145 from './images8/8_145.jpg';
import i8146 from './images8/8_146.jpg';
import i8147 from './images8/8_147.jpg';
import i8148 from './images8/8_148.jpg';
import i8149 from './images8/8_149.jpg';
import i8150 from './images8/8_150.jpg';
import i8151 from './images8/8_151.jpg';
import i8152 from './images8/8_152.jpg';
import i8153 from './images8/8_153.jpg';
import i91 from './images9/9_1.jpg';
import i92 from './images9/9_2.jpg';
import i93 from './images9/9_3.jpg';
import i94 from './images9/9_4.jpg';
import i95 from './images9/9_5.jpg';
import i96 from './images9/9_6.jpg';
import i97 from './images9/9_7.jpg';
import i98 from './images9/9_8.jpg';
import i99 from './images9/9_9.jpg';
import i910 from './images9/9_10.jpg';
import i911 from './images9/9_11.jpg';
import i912 from './images9/9_12.jpg';
import i913 from './images9/9_13.jpg';
import i914 from './images9/9_14.jpg';
import i915 from './images9/9_15.jpg';
import i916 from './images9/9_16.jpg';
import i917 from './images9/9_17.jpg';
import i918 from './images9/9_18.jpg';
import i919 from './images9/9_19.jpg';
import i920 from './images9/9_20.jpg';
import i921 from './images9/9_21.jpg';
import i922 from './images9/9_22.jpg';
import i923 from './images9/9_23.jpg';
import i924 from './images9/9_24.jpg';
import i925 from './images9/9_25.jpg';
import i926 from './images9/9_26.jpg';
import i927 from './images9/9_27.jpg';
import i928 from './images9/9_28.jpg';
import i929 from './images9/9_29.jpg';
import i930 from './images9/9_30.jpg';
import i931 from './images9/9_31.jpg';
import i932 from './images9/9_32.jpg';
import i933 from './images9/9_33.jpg';
import i934 from './images9/9_34.jpg';
import i935 from './images9/9_35.jpg';
import i936 from './images9/9_36.jpg';
import i937 from './images9/9_37.jpg';
import i938 from './images9/9_38.jpg';
import i939 from './images9/9_39.jpg';
import i940 from './images9/9_40.jpg';
import i941 from './images9/9_41.jpg';
import i942 from './images9/9_42.jpg';
import i943 from './images9/9_43.jpg';
import i944 from './images9/9_44.jpg';
import i945 from './images9/9_45.jpg';
import i946 from './images9/9_46.jpg';
import i947 from './images9/9_47.jpg';
import i948 from './images9/9_48.jpg';
import i949 from './images9/9_49.jpg';
import i950 from './images9/9_50.jpg';
import i951 from './images9/9_51.jpg';
import i952 from './images9/9_52.jpg';
import i953 from './images9/9_53.jpg';
import i954 from './images9/9_54.jpg';
import i955 from './images9/9_55.jpg';
import i956 from './images9/9_56.jpg';
import i957 from './images9/9_57.jpg';
import i958 from './images9/9_58.jpg';
import i959 from './images9/9_59.jpg';
import i960 from './images9/9_60.jpg';
import i961 from './images9/9_61.jpg';
import i962 from './images9/9_62.jpg';
import i963 from './images9/9_63.jpg';
import i964 from './images9/9_64.jpg';
import i965 from './images9/9_65.jpg';
import i966 from './images9/9_66.jpg';
import i967 from './images9/9_67.jpg';
import i968 from './images9/9_68.jpg';
import i969 from './images9/9_69.jpg';
import i970 from './images9/9_70.jpg';

import i101 from './images10/10_1.jpg';
import i102 from './images10/10_2.jpg';
import i103 from './images10/10_3.jpg';
import i104 from './images10/10_4.jpg';
import i105 from './images10/10_5.jpg';
import i106 from './images10/10_6.jpg';
import i107 from './images10/10_7.jpg';
import i108 from './images10/10_8.jpg';
import i109 from './images10/10_9.jpg';
import i1010 from './images10/10_10.jpg';
import i1011 from './images10/10_11.jpg';
import i1012 from './images10/10_12.jpg';
import i1013 from './images10/10_13.jpg';
import i1014 from './images10/10_14.jpg';
import i1015 from './images10/10_15.jpg';
import i1016 from './images10/10_16.jpg';
import i1017 from './images10/10_17.jpg';
import i1018 from './images10/10_18.jpg';
import i1019 from './images10/10_19.jpg';
import i1020 from './images10/10_20.jpg';
import i1021 from './images10/10_21.jpg';
import i1022 from './images10/10_22.jpg';
import i1023 from './images10/10_23.jpg';
import i1024 from './images10/10_24.jpg';
import i1025 from './images10/10_25.jpg';
import i1026 from './images10/10_26.jpg';
import i1027 from './images10/10_27.jpg';
import i1028 from './images10/10_28.jpg';
import i1029 from './images10/10_29.jpg';
import i1030 from './images10/10_30.jpg';
import i1031 from './images10/10_31.jpg';
import i1032 from './images10/10_32.jpg';
import i1033 from './images10/10_33.jpg';
import i1034 from './images10/10_34.jpg';
import i1035 from './images10/10_35.jpg';
import i1036 from './images10/10_36.jpg';
import i1037 from './images10/10_37.jpg';
import i1038 from './images10/10_38.jpg';
import i1039 from './images10/10_39.jpg';
import i1040 from './images10/10_40.jpg';
import i1041 from './images10/10_41.jpg';
import i1042 from './images10/10_42.jpg';
import i1043 from './images10/10_43.jpg';
import i1044 from './images10/10_44.jpg';
import i1045 from './images10/10_45.jpg';
import i1046 from './images10/10_46.jpg';
import i1047 from './images10/10_47.jpg';
import i1048 from './images10/10_48.jpg';
import i1049 from './images10/10_49.jpg';
import i1050 from './images10/10_50.jpg';
import i1051 from './images10/10_51.jpg';
import i1052 from './images10/10_52.jpg';
import i1053 from './images10/10_53.jpg';
import i1054 from './images10/10_54.jpg';
import i1055 from './images10/10_55.jpg';
import i1056 from './images10/10_56.jpg';
import i1057 from './images10/10_57.jpg';
import i1058 from './images10/10_58.jpg';
import i1059 from './images10/10_59.jpg';
import i1060 from './images10/10_60.jpg';
import i1061 from './images10/10_61.jpg';
import i1062 from './images10/10_62.jpg';
import i1063 from './images10/10_63.jpg';
import i1064 from './images10/10_64.jpg';
import i1065 from './images10/10_65.jpg';
import i1066 from './images10/10_66.jpg';
import i1067 from './images10/10_67.jpg';
import i1068 from './images10/10_68.jpg';
import i1069 from './images10/10_69.jpg';
import i1070 from './images10/10_70.jpg';
import i1071 from './images10/10_71.jpg';
import i1072 from './images10/10_72.jpg';
import i1073 from './images10/10_73.jpg';
import i1074 from './images10/10_74.jpg';
import i1075 from './images10/10_75.jpg';
import i1076 from './images10/10_76.jpg';
import i1077 from './images10/10_77.jpg';
import i1078 from './images10/10_78.jpg';
import i1079 from './images10/10_79.jpg';
import i1080 from './images10/10_80.jpg';
import i1081 from './images10/10_81.jpg';
import i1082 from './images10/10_82.jpg';
import i1083 from './images10/10_83.jpg';
import i1084 from './images10/10_84.jpg';
import i1085 from './images10/10_85.jpg';
import i1086 from './images10/10_86.jpg';
import i1087 from './images10/10_87.jpg';
import i1088 from './images10/10_88.jpg';
import i1089 from './images10/10_89.jpg';
import i1090 from './images10/10_90.jpg';
import i1091 from './images10/10_91.jpg';
import i1092 from './images10/10_92.jpg';
import i1093 from './images10/10_93.jpg';
import i1094 from './images10/10_94.jpg';
import i1095 from './images10/10_95.jpg';
import i1096 from './images10/10_96.jpg';
import i1097 from './images10/10_97.jpg';
import i1098 from './images10/10_98.jpg';
import i1099 from './images10/10_99.jpg';
import i10100 from './images10/10_100.jpg';
import i10101 from './images10/10_101.jpg';
import i10102 from './images10/10_102.jpg';
import i10103 from './images10/10_103.jpg';
import i10104 from './images10/10_104.jpg';
import i10105 from './images10/10_105.jpg';
import i10106 from './images10/10_106.jpg';
import i10107 from './images10/10_107.jpg';
import i10108 from './images10/10_108.jpg';
import i10109 from './images10/10_109.jpg';
import i10110 from './images10/10_110.jpg';
import i10111 from './images10/10_111.jpg';
import i10112 from './images10/10_112.jpg';
import i10113 from './images10/10_113.jpg';
import i10114 from './images10/10_114.jpg';
import i10115 from './images10/10_115.jpg';
import i10116 from './images10/10_116.jpg';
import i10117 from './images10/10_117.jpg';
import i10118 from './images10/10_118.jpg';
import i10119 from './images10/10_119.jpg';
import i10120 from './images10/10_120.jpg';
import i10121 from './images10/10_121.jpg';
import i10122 from './images10/10_122.jpg';
import i10123 from './images10/10_123.jpg';
import i10124 from './images10/10_124.jpg';
import i10125 from './images10/10_125.jpg';
import i10126 from './images10/10_126.jpg';
import i10127 from './images10/10_127.jpg';
import i10128 from './images10/10_128.jpg';
import i10129 from './images10/10_129.jpg';
import i10130 from './images10/10_130.jpg';
import i10131 from './images10/10_131.jpg';
import i10132 from './images10/10_132.jpg';
import i111 from './images11/11_1.jpg';
import i112 from './images11/11_2.jpg';
import i113 from './images11/11_3.jpg';
import i114 from './images11/11_4.jpg';
import i115 from './images11/11_5.jpg';
import i116 from './images11/11_6.jpg';
import i117 from './images11/11_7.jpg';
import i118 from './images11/11_8.jpg';
import i119 from './images11/11_9.jpg';
import i1110 from './images11/11_10.jpg';
import i1111 from './images11/11_11.jpg';
import i1112 from './images11/11_12.jpg';
import i1113 from './images11/11_13.jpg';
import i1114 from './images11/11_14.jpg';
import i1115 from './images11/11_15.jpg';
import i1116 from './images11/11_16.jpg';
import i1117 from './images11/11_17.jpg';
import i1118 from './images11/11_18.jpg';
import i1119 from './images11/11_19.jpg';
import i1120 from './images11/11_20.jpg';
import i1121 from './images11/11_21.jpg';
import i1122 from './images11/11_22.jpg';
import i1123 from './images11/11_23.jpg';
import i1124 from './images11/11_24.jpg';
import i1125 from './images11/11_25.jpg';
import i1126 from './images11/11_26.jpg';
import i1127 from './images11/11_27.jpg';
import i1128 from './images11/11_28.jpg';
import i1129 from './images11/11_29.jpg';
import i1130 from './images11/11_30.jpg';
import i1131 from './images11/11_31.jpg';
import i1132 from './images11/11_32.jpg';
import i1133 from './images11/11_33.jpg';
import i1134 from './images11/11_34.jpg';
import i1135 from './images11/11_35.jpg';
import i1136 from './images11/11_36.jpg';
import i1137 from './images11/11_37.jpg';
import i1138 from './images11/11_38.jpg';
import i1139 from './images11/11_39.jpg';
import i1140 from './images11/11_40.jpg';
import i1141 from './images11/11_41.jpg';
import i1142 from './images11/11_42.jpg';
import i1143 from './images11/11_43.jpg';
import i1144 from './images11/11_44.jpg';
import i1145 from './images11/11_45.jpg';
import i1146 from './images11/11_46.jpg';
import i1147 from './images11/11_47.jpg';
import i1148 from './images11/11_48.jpg';
import i1149 from './images11/11_49.jpg';
import i1150 from './images11/11_50.jpg';
import i1151 from './images11/11_51.jpg';
import i1152 from './images11/11_52.jpg';
import i1153 from './images11/11_53.jpg';
import i1154 from './images11/11_54.jpg';
import i1155 from './images11/11_55.jpg';
import i1156 from './images11/11_56.jpg';
import i1157 from './images11/11_57.jpg';
import i1158 from './images11/11_58.jpg';
import i1159 from './images11/11_59.jpg';
import i1160 from './images11/11_60.jpg';
import i1161 from './images11/11_61.jpg';
import i1162 from './images11/11_62.jpg';
import i1163 from './images11/11_63.jpg';
import i1164 from './images11/11_64.jpg';
import i1165 from './images11/11_65.jpg';
import i1166 from './images11/11_66.jpg';
import i1167 from './images11/11_67.jpg';
import i1168 from './images11/11_68.jpg';
import i1169 from './images11/11_69.jpg';
import i1170 from './images11/11_70.jpg';
import i1171 from './images11/11_71.jpg';
import i1172 from './images11/11_72.jpg';
import i1173 from './images11/11_73.jpg';
import i1174 from './images11/11_74.jpg';
import i1175 from './images11/11_75.jpg';
import i1176 from './images11/11_76.jpg';
import i1177 from './images11/11_77.jpg';
import i1178 from './images11/11_78.jpg';
import i1179 from './images11/11_79.jpg';
import i1180 from './images11/11_80.jpg';
import i1181 from './images11/11_81.jpg';
import i1182 from './images11/11_82.jpg';
import i1183 from './images11/11_83.jpg';
import i1184 from './images11/11_84.jpg';
import i1185 from './images11/11_85.jpg';
import i1186 from './images11/11_86.jpg';
import i1187 from './images11/11_87.jpg';
import i1188 from './images11/11_88.jpg';
import i1189 from './images11/11_89.jpg';
import i1190 from './images11/11_90.jpg';
import i1191 from './images11/11_91.jpg';
import i1192 from './images11/11_92.jpg';
import i1193 from './images11/11_93.jpg';
import i1194 from './images11/11_94.jpg';
import i1195 from './images11/11_95.jpg';
import i1196 from './images11/11_96.jpg';
import i1197 from './images11/11_97.jpg';
import i1198 from './images11/11_98.jpg';
import i1199 from './images11/11_99.jpg';
import i11100 from './images11/11_100.jpg';
import i11101 from './images11/11_101.jpg';
import i11102 from './images11/11_102.jpg';
import i11103 from './images11/11_103.jpg';
import i11104 from './images11/11_104.jpg';
import i11105 from './images11/11_105.jpg';
import i11106 from './images11/11_106.jpg';
import i11107 from './images11/11_107.jpg';
import i11108 from './images11/11_108.jpg';
import i11109 from './images11/11_109.jpg';
import i121 from './images12/12_1.jpg';
import i122 from './images12/12_2.jpg';
import i123 from './images12/12_3.jpg';
import i124 from './images12/12_4.jpg';
import i125 from './images12/12_5.jpg';
import i126 from './images12/12_6.jpg';
import i127 from './images12/12_7.jpg';
import i128 from './images12/12_8.jpg';
import i129 from './images12/12_9.jpg';
import i1210 from './images12/12_10.jpg';
import i1211 from './images12/12_11.jpg';
import i1212 from './images12/12_12.jpg';
import i1213 from './images12/12_13.jpg';
import i1214 from './images12/12_14.jpg';
import i1215 from './images12/12_15.jpg';
import i1216 from './images12/12_16.jpg';
import i1217 from './images12/12_17.jpg';
import i1218 from './images12/12_18.jpg';
import i1219 from './images12/12_19.jpg';
import i1220 from './images12/12_20.jpg';
import i1221 from './images12/12_21.jpg';
import i1222 from './images12/12_22.jpg';
import i1223 from './images12/12_23.jpg';
import i1224 from './images12/12_24.jpg';
import i1225 from './images12/12_25.jpg';
import i1226 from './images12/12_26.jpg';
import i1227 from './images12/12_27.jpg';
import i1228 from './images12/12_28.jpg';
import i1229 from './images12/12_29.jpg';
import i1230 from './images12/12_30.jpg';
import i1231 from './images12/12_31.jpg';
import i1232 from './images12/12_32.jpg';
import i1233 from './images12/12_33.jpg';
import i1234 from './images12/12_34.jpg';
import i1235 from './images12/12_35.jpg';
import i1236 from './images12/12_36.jpg';
import i1237 from './images12/12_37.jpg';
import i1238 from './images12/12_38.jpg';
import i1239 from './images12/12_39.jpg';
import i1240 from './images12/12_40.jpg';
import i1241 from './images12/12_41.jpg';
import i1242 from './images12/12_42.jpg';
import i1243 from './images12/12_43.jpg';
import i1244 from './images12/12_44.jpg';
import i1245 from './images12/12_45.jpg';
import i1246 from './images12/12_46.jpg';
import i1247 from './images12/12_47.jpg';
import i1248 from './images12/12_48.jpg';
import i1249 from './images12/12_49.jpg';
import i1250 from './images12/12_50.jpg';
import i1251 from './images12/12_51.jpg';
import i1252 from './images12/12_52.jpg';
import i1253 from './images12/12_53.jpg';
import i1254 from './images12/12_54.jpg';
import i1255 from './images12/12_55.jpg';
import i1256 from './images12/12_56.jpg';
import i1257 from './images12/12_57.jpg';
import i1258 from './images12/12_58.jpg';
import i1259 from './images12/12_59.jpg';
import i1260 from './images12/12_60.jpg';
import i1261 from './images12/12_61.jpg';
import i1262 from './images12/12_62.jpg';
import i1263 from './images12/12_63.jpg';
import i1264 from './images12/12_64.jpg';
import i1265 from './images12/12_65.jpg';
import i1266 from './images12/12_66.jpg';
import i1267 from './images12/12_67.jpg';
import i1268 from './images12/12_68.jpg';
import i1269 from './images12/12_69.jpg';
import i1270 from './images12/12_70.jpg';
import i1271 from './images12/12_71.jpg';
import i1272 from './images12/12_72.jpg';
import i1273 from './images12/12_73.jpg';
import i1274 from './images12/12_74.jpg';
import i1275 from './images12/12_75.jpg';
import i1276 from './images12/12_76.jpg';
import i1277 from './images12/12_77.jpg';
import i1278 from './images12/12_78.jpg';
import i1279 from './images12/12_79.jpg';
import i1280 from './images12/12_80.jpg';
import i1281 from './images12/12_81.jpg';
import i1282 from './images12/12_82.jpg';
import i1283 from './images12/12_83.jpg';
import i1284 from './images12/12_84.jpg';
import i1285 from './images12/12_85.jpg';
import i1286 from './images12/12_86.jpg';
import i1287 from './images12/12_87.jpg';
import i1288 from './images12/12_88.jpg';
import i1289 from './images12/12_89.jpg';
import i1290 from './images12/12_90.jpg';
import i1291 from './images12/12_91.jpg';
import i1292 from './images12/12_92.jpg';
import i1293 from './images12/12_93.jpg';
import i1294 from './images12/12_94.jpg';
import i1295 from './images12/12_95.jpg';
import i1296 from './images12/12_96.jpg';
import i1297 from './images12/12_97.jpg';
import i1298 from './images12/12_98.jpg';
import i1299 from './images12/12_99.jpg';
import i12100 from './images12/12_100.jpg';
import i12101 from './images12/12_101.jpg';
import i12102 from './images12/12_102.jpg';
import i12103 from './images12/12_103.jpg';
import i12104 from './images12/12_104.jpg';
import i12105 from './images12/12_105.jpg';
import i12106 from './images12/12_106.jpg';
import i12107 from './images12/12_107.jpg';
import i12108 from './images12/12_108.jpg';
import i12109 from './images12/12_109.jpg';
import i12110 from './images12/12_110.jpg';
import i12111 from './images12/12_111.jpg';
import i12112 from './images12/12_112.jpg';
import i12113 from './images12/12_113.jpg';
import i12114 from './images12/12_114.jpg';
import i12115 from './images12/12_115.jpg';
import i12116 from './images12/12_116.jpg';
import i12117 from './images12/12_117.jpg';
import i12118 from './images12/12_118.jpg';
import i12119 from './images12/12_119.jpg';
import i12120 from './images12/12_120.jpg';
import i12121 from './images12/12_121.jpg';
import i12122 from './images12/12_122.jpg';
import i12123 from './images12/12_123.jpg';
import i12124 from './images12/12_124.jpg';
import i12125 from './images12/12_125.jpg';
import i12126 from './images12/12_126.jpg';
import i12127 from './images12/12_127.jpg';
import i12128 from './images12/12_128.jpg';
import i12129 from './images12/12_129.jpg';
import i12130 from './images12/12_130.jpg';
import i12131 from './images12/12_131.jpg';
import i12132 from './images12/12_132.jpg';
import i12133 from './images12/12_133.jpg';
import i12134 from './images12/12_134.jpg';
import i12135 from './images12/12_135.jpg';
import i12136 from './images12/12_136.jpg';
import i12137 from './images12/12_137.jpg';
import i12138 from './images12/12_138.jpg';
import i12139 from './images12/12_139.jpg';
import i12140 from './images12/12_140.jpg';
import i12141 from './images12/12_141.jpg';
import i12142 from './images12/12_142.jpg';
import i12143 from './images12/12_143.jpg';
import i12144 from './images12/12_144.jpg';
import i12145 from './images12/12_145.jpg';
import i12146 from './images12/12_146.jpg';
import i12147 from './images12/12_147.jpg';
import i12148 from './images12/12_148.jpg';
import i12149 from './images12/12_149.jpg';
import i12150 from './images12/12_150.jpg';
import i12151 from './images12/12_151.jpg';
import i131 from './images13/13_1.jpg';
import i132 from './images13/13_2.jpg';
import i133 from './images13/13_3.jpg';
import i134 from './images13/13_4.jpg';
import i135 from './images13/13_5.jpg';
import i136 from './images13/13_6.jpg';
import i137 from './images13/13_7.jpg';
import i141 from './images14/14_1.jpg';
import i142 from './images14/14_2.jpg';
import i143 from './images14/14_3.jpg';
import i144 from './images14/14_4.jpg';
import i145 from './images14/14_5.jpg';
import i146 from './images14/14_6.jpg';
import i147 from './images14/14_7.jpg';
import i151 from './images15/15_1.jpg';
import i152 from './images15/15_2.jpg';
import i153 from './images15/15_3.jpg';
import i154 from './images15/15_4.jpg';
import i155 from './images15/15_5.jpg';
import i156 from './images15/15_6.jpg';
import i157 from './images15/15_7.jpg';
import i158 from './images15/15_8.jpg';
import i159 from './images15/15_9.jpg';
import i1510 from './images15/15_10.jpg';
import i1511 from './images15/15_11.jpg';
import i1512 from './images15/15_12.jpg';
import i1513 from './images15/15_13.jpg';
import i1514 from './images15/15_14.jpg';
import i1515 from './images15/15_15.jpg';
import i1516 from './images15/15_16.jpg';
import i1517 from './images15/15_17.jpg';
import i1518 from './images15/15_18.jpg';
import i1519 from './images15/15_19.jpg';
import i1520 from './images15/15_20.jpg';
import i1521 from './images15/15_21.jpg';
import i1522 from './images15/15_22.jpg';
import i1523 from './images15/15_23.jpg';
import i1524 from './images15/15_24.jpg';
import i1525 from './images15/15_25.jpg';
import i1526 from './images15/15_26.jpg';
import i1527 from './images15/15_27.jpg';
import i1528 from './images15/15_28.jpg';
import i1529 from './images15/15_29.jpg';
import i1530 from './images15/15_30.jpg';
import i1531 from './images15/15_31.jpg';
import i1532 from './images15/15_32.jpg';
import i1533 from './images15/15_33.jpg';
import i1534 from './images15/15_34.jpg';
import i1535 from './images15/15_35.jpg';
import i1536 from './images15/15_36.jpg';
import i1537 from './images15/15_37.jpg';
import i1538 from './images15/15_38.jpg';
import i1539 from './images15/15_39.jpg';
import i1540 from './images15/15_40.jpg';
import i1541 from './images15/15_41.jpg';
import i1542 from './images15/15_42.jpg';
import i1543 from './images15/15_43.jpg';
import i1544 from './images15/15_44.jpg';
import i1545 from './images15/15_45.jpg';
import i1546 from './images15/15_46.jpg';
import i1547 from './images15/15_47.jpg';
import i1548 from './images15/15_48.jpg';
import i1549 from './images15/15_49.jpg';
import i1550 from './images15/15_50.jpg';
import i1551 from './images15/15_51.jpg';
import i1552 from './images15/15_52.jpg';
import i1553 from './images15/15_53.jpg';
import i1554 from './images15/15_54.jpg';
import i1555 from './images15/15_55.jpg';
import i1556 from './images15/15_56.jpg';
import i1557 from './images15/15_57.jpg';
import i1558 from './images15/15_58.jpg';
import i1559 from './images15/15_59.jpg';
import i1560 from './images15/15_60.jpg';
import i1561 from './images15/15_61.jpg';
import i1562 from './images15/15_62.jpg';
import i1563 from './images15/15_63.jpg';
import i1564 from './images15/15_64.jpg';
import i1565 from './images15/15_65.jpg';
import i1566 from './images15/15_66.jpg';
import i1567 from './images15/15_67.jpg';
import i1568 from './images15/15_68.jpg';
import i1569 from './images15/15_69.jpg';
import i1570 from './images15/15_70.jpg';
import i1571 from './images15/15_71.jpg';
import i1572 from './images15/15_72.jpg';
import i1573 from './images15/15_73.jpg';
import i1574 from './images15/15_74.jpg';
import i1575 from './images15/15_75.jpg';
import i1576 from './images15/15_76.jpg';
import i1577 from './images15/15_77.jpg';
import i1578 from './images15/15_78.jpg';
import i161 from './images16/16_1.jpg';
import i162 from './images16/16_2.jpg';
import i163 from './images16/16_3.jpg';
import i171 from './images17/17_1.jpg';
import i172 from './images17/17_2.jpg';
import i173 from './images17/17_3.jpg';
import i174 from './images17/17_4.jpg';
import i175 from './images17/17_5.jpg';
import i176 from './images17/17_6.jpg';
import i177 from './images17/17_7.jpg';
import i178 from './images17/17_8.jpg';
import i179 from './images17/17_9.jpg';
import i1710 from './images17/17_10.jpg';
import i1711 from './images17/17_11.jpg';
import i1712 from './images17/17_12.jpg';
import i1713 from './images17/17_13.jpg';
import i181 from './images18/18_1.jpg';
import i182 from './images18/18_2.jpg';
import i183 from './images18/18_3.jpg';
import i184 from './images18/18_4.jpg';
import i185 from './images18/18_5.jpg';
import i186 from './images18/18_6.jpg';
import i187 from './images18/18_7.jpg';
import i188 from './images18/18_8.jpg';
import i189 from './images18/18_9.jpg';
import i1810 from './images18/18_10.jpg';
import i1811 from './images18/18_11.jpg';
import i1812 from './images18/18_12.jpg';
import i1813 from './images18/18_13.jpg';
import i1814 from './images18/18_14.jpg';
import i1815 from './images18/18_15.jpg';
import i1816 from './images18/18_16.jpg';
import i1817 from './images18/18_17.jpg';
import i1818 from './images18/18_18.jpg';
import i1819 from './images18/18_19.jpg';
import i1820 from './images18/18_20.jpg';
import i1821 from './images18/18_21.jpg';
import i1822 from './images18/18_22.jpg';
import i1823 from './images18/18_23.jpg';
import i1824 from './images18/18_24.jpg';
import i1825 from './images18/18_25.jpg';
import i1826 from './images18/18_26.jpg';
import i1827 from './images18/18_27.jpg';
import i1828 from './images18/18_28.jpg';
import i1829 from './images18/18_29.jpg';
import i1830 from './images18/18_30.jpg';
import i1831 from './images18/18_31.jpg';
import i1832 from './images18/18_32.jpg';
import i1833 from './images18/18_33.jpg';
import i1834 from './images18/18_34.jpg';
import i1835 from './images18/18_35.jpg';
import i1836 from './images18/18_36.jpg';
import i1837 from './images18/18_37.jpg';
import i1838 from './images18/18_38.jpg';
import i1839 from './images18/18_39.jpg';
import i1840 from './images18/18_40.jpg';
import i1841 from './images18/18_41.jpg';
import i1842 from './images18/18_42.jpg';
import i1843 from './images18/18_43.jpg';
import i1844 from './images18/18_44.jpg';
import i1845 from './images18/18_45.jpg';
import i1846 from './images18/18_46.jpg';
import i1847 from './images18/18_47.jpg';
import i1848 from './images18/18_48.jpg';
import i1849 from './images18/18_49.jpg';
import i1850 from './images18/18_50.jpg';
import i1851 from './images18/18_51.jpg';
import i1852 from './images18/18_52.jpg';
import i1853 from './images18/18_53.jpg';
import i1854 from './images18/18_54.jpg';
import i1855 from './images18/18_55.jpg';
import i1856 from './images18/18_56.jpg';
import i1857 from './images18/18_57.jpg';
import i1858 from './images18/18_58.jpg';
import i1859 from './images18/18_59.jpg';
import i1860 from './images18/18_60.jpg';
import i1861 from './images18/18_61.jpg';
import i1862 from './images18/18_62.jpg';
import i1863 from './images18/18_63.jpg';
import i1864 from './images18/18_64.jpg';
import i1865 from './images18/18_65.jpg';
import i1866 from './images18/18_66.jpg';
import i1867 from './images18/18_67.jpg';
import i1868 from './images18/18_68.jpg';
import i1869 from './images18/18_69.jpg';
import i1870 from './images18/18_70.jpg';
import i1871 from './images18/18_71.jpg';
import i1872 from './images18/18_72.jpg';
import i1873 from './images18/18_73.jpg';
import i1874 from './images18/18_74.jpg';
import i1875 from './images18/18_75.jpg';
import i1876 from './images18/18_76.jpg';
import i1877 from './images18/18_77.jpg';
import i1878 from './images18/18_78.jpg';
import i1879 from './images18/18_79.jpg';
import i1880 from './images18/18_80.jpg';
import i1881 from './images18/18_81.jpg';
import i1882 from './images18/18_82.jpg';
import i1883 from './images18/18_83.jpg';
import i1884 from './images18/18_84.jpg';
import i1885 from './images18/18_85.jpg';
import i1886 from './images18/18_86.jpg';
import i1887 from './images18/18_87.jpg';
import i1888 from './images18/18_88.jpg';
import i1889 from './images18/18_89.jpg';
import i1890 from './images18/18_90.jpg';
import i1891 from './images18/18_91.jpg';
import i1892 from './images18/18_92.jpg';
import i1893 from './images18/18_93.jpg';
import i1894 from './images18/18_94.jpg';
import i1895 from './images18/18_95.jpg';
import i1896 from './images18/18_96.jpg';
import i1897 from './images18/18_97.jpg';
import i191 from './images19/19_1.jpg';
import i192 from './images19/19_2.jpg';
import i193 from './images19/19_3.jpg';
import i194 from './images19/19_4.jpg';
import i195 from './images19/19_5.jpg';
import i196 from './images19/19_6.jpg';
import i197 from './images19/19_7.jpg';
import i198 from './images19/19_8.jpg';
import i199 from './images19/19_9.jpg';
const Images12 = [
  i121, i122, i123, i124, i125, i126, i127, i128, i129, i1210,
  i1211, i1212, i1213, i1214, i1215, i1216, i1217, i1218, i1219, i1220,
  i1221, i1222, i1223, i1224, i1225, i1226, i1227, i1228, i1229, i1230,
  i1231, i1232, i1233, i1234, i1235, i1236, i1237, i1238, i1239, i1240,
  i1241, i1242, i1243, i1244, i1245, i1246, i1247, i1248, i1249, i1250,
  i1251, i1252, i1253, i1254, i1255, i1256, i1257, i1258, i1259, i1260,
  i1261, i1262, i1263, i1264, i1265, i1266, i1267, i1268, i1269, i1270,
  i1271, i1272, i1273, i1274, i1275, i1276, i1277, i1278, i1279, i1280,
  i1281, i1282, i1283, i1284, i1285, i1286, i1287, i1288, i1289, i1290,
  i1291, i1292, i1293, i1294, i1295, i1296, i1297, i1298, i1299, i12100,
  i12101, i12102, i12103, i12104, i12105, i12106, i12107, i12108, i12109,
  i12110, i12111, i12112, i12113, i12114, i12115, i12116, i12117, i12118, i12119,
  i12120, i12121, i12122, i12123, i12124, i12125, i12126, i12127, i12128, i12129,
  i12130, i12131, i12132, i12133, i12134, i12135, i12136, i12137, i12138, i12139,
  i12140, i12141, i12142, i12143, i12144, i12145, i12146, i12147, i12148, i12149,
  i12150, i12151
];
const Images19 = [
  i191, i192, i193, i194, i195, i196, i197, i198, i199
];
const Images13 = [
  i131, i132, i133, i134, i135, i136, i137
];
const Images14 = [
  i141, i142, i143, i144, i145, i146, i147
];
const Images15 = [
  i151, i152, i153, i154, i155, i156, i157, i158, i159, i1510,
  i1511, i1512, i1513, i1514, i1515, i1516, i1517, i1518, i1519, i1520,
  i1521, i1522, i1523, i1524, i1525, i1526, i1527, i1528, i1529, i1530,
  i1531, i1532, i1533, i1534, i1535, i1536, i1537, i1538, i1539, i1540,
  i1541, i1542, i1543, i1544, i1545, i1546, i1547, i1548, i1549, i1550,
  i1551, i1552, i1553, i1554, i1555, i1556, i1557, i1558, i1559, i1560,
  i1561, i1562, i1563, i1564, i1565, i1566, i1567, i1568, i1569, i1570,
  i1571, i1572, i1573, i1574, i1575, i1576, i1577, i1578
];
const Images16 = [
  i161, i162, i163
];
const Images17 = [
  i171, i172, i173, i174, i175, i176, i177, i178, i179, i1710,
  i1711, i1712, i1713
];
const Images18 = [
  i181, i182, i183, i184, i185, i186, i187, i188, i189, i1810,
  i1811, i1812, i1813, i1814, i1815, i1816, i1817, i1818, i1819, i1820,
  i1821, i1822, i1823, i1824, i1825, i1826, i1827, i1828, i1829, i1830,
  i1831, i1832, i1833, i1834, i1835, i1836, i1837, i1838, i1839, i1840,
  i1841, i1842, i1843, i1844, i1845, i1846, i1847, i1848, i1849, i1850,
  i1851, i1852, i1853, i1854, i1855, i1856, i1857, i1858, i1859, i1860,
  i1861, i1862, i1863, i1864, i1865, i1866, i1867, i1868, i1869, i1870,
  i1871, i1872, i1873, i1874, i1875, i1876, i1877, i1878, i1879, i1880,
  i1881, i1882, i1883, i1884, i1885, i1886, i1887, i1888, i1889, i1890,
  i1891, i1892, i1893, i1894, i1895, i1896, i1897
];
const Images10 = [
  i101, i102, i103, i104, i105, i106, i107, i108, i109, i1010,
  i1011, i1012, i1013, i1014, i1015, i1016, i1017, i1018, i1019, i1020,
  i1021, i1022, i1023, i1024, i1025, i1026, i1027, i1028, i1029, i1030,
  i1031, i1032, i1033, i1034, i1035, i1036, i1037, i1038, i1039, i1040,
  i1041, i1042, i1043, i1044, i1045, i1046, i1047, i1048, i1049, i1050,
  i1051, i1052, i1053, i1054, i1055, i1056, i1057, i1058, i1059, i1060,
  i1061, i1062, i1063, i1064, i1065, i1066, i1067, i1068, i1069, i1070,
  i1071, i1072, i1073, i1074, i1075, i1076, i1077, i1078, i1079, i1080,
  i1081, i1082, i1083, i1084, i1085, i1086, i1087, i1088, i1089, i1090,
  i1091, i1092, i1093, i1094, i1095, i1096, i1097, i1098, i1099, i10100,
  i10101, i10102, i10103, i10104, i10105, i10106, i10107, i10108, i10109, i10110,
  i10111, i10112, i10113, i10114, i10115, i10116, i10117, i10118, i10119, i10120,
  i10121, i10122, i10123, i10124, i10125, i10126, i10127, i10128, i10129, i10130,
  i10131, i10132
];
const Images11 = [i111,i112,i113,i114,i115,i116,i117,i118,
  i119, i1110, i1111, i1112, i1113, i1114, i1115, i1116, i1117, i1118,
  i1119, i1120, i1121, i1122, i1123, i1124, i1125, i1126, i1127, i1128,
  i1129, i1130, i1131, i1132, i1133, i1134, i1135, i1136, i1137, i1138,
  i1139, i1140, i1141, i1142, i1143, i1144, i1145, i1146, i1147, i1148,
  i1149, i1150, i1151, i1152, i1153, i1154, i1155, i1156, i1157, i1158,
  i1159, i1160, i1161, i1162, i1163, i1164, i1165, i1166, i1167, i1168,
  i1169, i1170, i1171, i1172, i1173, i1174, i1175, i1176, i1177, i1178,
  i1179, i1180, i1181, i1182, i1183, i1184, i1185, i1186, i1187, i1188,
  i1189, i1190, i1191, i1192, i1193, i1194, i1195, i1196, i1197, i1198,
  i1199, i11100, i11101, i11102, i11103, i11104, i11105, i11106, i11107, i11108,
  i11109
];
const Images8 = [  i81, i82, i83, i84, i85, i86, i87, i88, i89, i810,
  i811, i812, i813, i814, i815, i816, i817, i818, i819, i820,
  i821, i822, i823, i824, i825, i826, i827, i828, i829, i830,
  i831, i832, i833, i834, i835, i836, i837, i838, i839, i840,
  i841, i842, i843, i844, i845, i846, i847, i848, i849, i850,
  i851, i852, i853, i854, i855, i856, i857, i858, i859, i860,
  i861, i862, i863, i864, i865, i866, i867, i868, i869, i870,
  i871, i872, i873, i874, i875, i876, i877, i878, i879, i880,
  i881, i882, i883, i884, i885, i886, i887, i888, i889, i890,
  i891, i892, i893, i894, i895, i896, i897, i898, i899, i8100,
  i8101, i8102, i8103, i8104, i8105, i8106, i8107, i8108, i8109, i8110,i8111, i8112, i8113, i8114, i8115, i8116, i8117, i8118, i8119, i8120,
  i8121, i8122, i8123, i8124, i8125, i8126, i8127, i8128, i8129, i8130,
  i8131, i8132, i8133, i8134, i8135, i8136, i8137, i8138, i8139, i8140,
  i8141, i8142, i8143, i8144, i8145, i8146, i8147, i8148, i8149, i8150,
  i8151, i8152, i8153
];



const Images7 = [
  i71, i72, i73, i74, i75, i76, i77, i78, i79, i710,
  i711, i712, i713, i714, i715, i716, i717, i718, i719, i720,
  i721, i722, i723, i724, i725, i726, i727, i728, i729, 
  i731, i732, i733, i734, i735, i736, i737, i738, i739, i740
];
const Images9 = [
  i91, i92, i93, i94, i95, i96, i97, i98, i99, i910,
  i911, i912, i913, i914, i915, i916, i917, i918, i919, i920,
  i921, i922, i923, i924, i925, i926, i927, i928, i929,
  i930, i931, i932, i933, i934, i935, i936, i937, i938, i939,
  i940, i941, i942, i943, i944, i945, i946, i947, i948, i949,
  i950, i951, i952, i953, i954, i955, i956, i957, i958, i959,
  i960, i961, i962, i963, i964, i965, i966, i967, i968, i969,
  i970
];
const Images6 = [i61, i62, i63, i64, i65, i66];
const Images5 = [i51, i52, i53, i54];
const Images4 = [i41, i42, i43];
const Images3 = [i31, i32, i33, i34];
const thumbnails = [
  t1, t2, t3, t4, t5, t6, t7, t8, t9, t10,
  t11, t12, t13, t14, t15, t16, t17, t18, t19
];
const Images1 = [
  i011,i012,i013,i014,i015,i016,i017,i018,i019,i0110,i0111,i0112,i0113,i0114
]
const Images2 = [i21, i22, i24, i25,i26];



const cardsData = [
  {
    id: 1,
    thumbnail: thumbnails[0],
    title: 'Liminal Spaces',
    description: '',
    details: `
      Some sample pictures of Liminal Spaces to be found online.\n
      Classical threshold places, similar to Heterotopias and Non Places.\n
      In the context of the internet phenomenon Liminal Spaces, it is more about the feeling that the images evoke than what they depict.\n
      Simple definition of these images:  Human-made or manipulated structures, emptied of human presence, emitting a strange feeling of familiarity (nostalgia) and uncanniness.\n
      Liminal Spaces is a vast term that includes many subgenres: poolrooms, backrooms, dreamcore, dreamscape architecture, etc.\n
      I recognized a spectre of kitsch and eerieness in many of the popular images and will sort them below from eerie to kitsch.
    `,
    images: Images1,
  },
  {
    id: 2,
    thumbnail: thumbnails[1],
    title: 'Background',
    description: '',
    details: `I do love Blender and work with Blender since 4 years. Oddly enough I always tend to
    build rooms in it. 
    At some point I was interested in recreating things made by nature, but I find geometrical structures much easier and more interesting. 
    Rather recreating manmade architecture than complexity of nature.
    I'm mostly interested in scenes with glass, water and complex lighting.
    
    Following some pictures of projects I did before.
    `,
    images: Images2,
  },
  {
    id: 3,
    thumbnail: thumbnails[2],
    title: 'First Experiments',
    description: '15/3/2023',
    details: `
    Inspired by the rather kitsch subgenre Poolrooms, I created my own Poolroom. I used a reference picture from an indoor swimming pool
    and improvised things I could not see from the reference.
    
    By changing the lighting and materials of the scenes, I wanted to convey my plan of how I'd go about creating liminal spaces.
    Through those first images I was confronted with the question about how to make something feel realistic. I decided to work with chosen places,
    from which I know the exact proportions.
    
    
    `,
    images: Images3,
  },
  {
    id: 4,
    thumbnail: thumbnails[3],
    title: 'Real Places',
    description: '20/4/2023',
    details: `Since proportions are important for the realness factor, I decided to work with places that are easily accessible for me. I decided on
    a swimming pool (Eglisee), a shopping centre (Stücki) and a Side Alley, as models to rebuild and make liminal. I used photographs I took and architectural plans
    as references.`,
    images: Images4,
  },
  {
    id: 5,
    thumbnail: thumbnails[4],
    title: 'Eglisee',
    description: '9/5/2023',
    details: `
    I was allowed to come to the Eglisee before the official season began and could take pictures of the empty pools. They did not have any architectural
    plans but provided me with the info of the poollengths.
    With the help of google Maps i could place the pools in true perspective. `,
    images: Images5,
  },
  {
    id: 6,
    thumbnail: thumbnails[5],
    title: 'Building Process Eglisee',
    description: '22/5/2023',
    details: `I started by building the pools with the ladders, steps and worked from the pools outwards and added more details on the go. First came
    concrete enclosure around the pools with water drains. Then the showers and grass beds. The changing rooms, and arena steps, windows, doors,
    the tower, lamps, jump tower, meadows, high rises.
    
    Furthermore I installed 10 cameras around the scene, to view the scene from different fixed directions.`,
    images: Images6,
  },
  {
    id: 7,
    thumbnail: thumbnails[6],
    title: 'Materials',
    description: '5/6/2023',
    details: `After building the raw structure of the roughly 150 metres long scene, I used different materials to get an overview of the renders.
    While building the objects I already put basic materials on the meshes to keep them apart and help me visualize.
    By using an override material, i rendered pictures with a grey rather rough material. In another try, I made all objects have a refractive glass material, that would
    divide passing light into a rainbow spectre. The render times for the two different materials were crass different. 1 hour for the grey material, 16 hours for the glass material.
    Since i wanted to elude from the fact that the area around of the building was empty, I also added fog.
    
    `,
    images: Images7,
  },
  {
    id: 8,
    thumbnail: thumbnails[7],
    title: 'Lighting',
    description: '7/6/2023  -  26/6/2023',
    details: `Lighting is an important part of 3D renders, without any lights the renders would be black. Following experiments show highlights from renders where I mostly relied
    on a few lights visible in the scene and changed the colour of them. 
    I also used a simple monocolour background picture that emits colour over the whole world with varying intensity. There are also some experiments with fog.
    Some renders feature invisible area lamps. In others I added water to the scene.
    
    I also started playing around with the render settings, since a lot of the images were very grainy.`,
    images: Images8,
  },
  {
    id: 9,
    thumbnail: thumbnails[8],
    title: 'Enviroment',
    description: '18/7/2023',
    details: `By using an HDRI file on the Sky, we can influence from where light falls into the map. While thinking about the classical sense of liminal spaces as transitional periods,
    I used different photographs from phases in my life as a sky texture. I liked the results and also decided it was time to set up a good sky texture and environemnt.`,
    images: Images9,
  },
  {
    id: 10,
    thumbnail: thumbnails[9],
    title: 'Realism with sky',
    description: '26/7/2023',
    details: `By adding a sky texture I could better control the shadows and the overall look of the renders. Some pictures would look as if the were shot on a gleemingly
    hot day at the zenit of the sun, others could resemble sandstorm weather. I also added some water into the pools with some renders, which changes the overall 
    atmosphere towards more cozy. I also added bloom to the final render to have lit objects create a blur.`,
    images: Images10,
  },  
  {
      id: 11,
      thumbnail: thumbnails[10],
      title: 'Camera Settings',
      description: '26/6/2023',
      details:`The camera settings decide on the outlook of the render. I was mostly playing around with depth of field and focus length. I learned that a smaller focus length would
      make the image feel more liminal, fitting more content in view but also distorting it from common human perspective.
      
      Since many liminal spaces pictures are taken with old cellphone cameras or similar grainy quality inducing media, I added a VHS filter on top of some renders, but found it too extreme.
      `,
      images: Images11,
  },
  {
      id: 12,
      thumbnail: thumbnails[11],
      title: 'Final Experiments Eglisee',
      description: '30/7/2023',
      details: `As you can see i accumulated many pictures through the ten cameras but only seldomly was very sure of achieving a liminal feeling. After some more experiments regarding texture, I decided to focus on one single camera perspective with a narrow focus length

      I decided on a camera view onto the Eglisee, which did not tell too much about the missing environment behind it and still showed some of the map. In regards to neutral liminal I envisioned a dark scene with comfortable lighting in the building. In Kitsch I imagined a sundown that puts ervything in a pink light. Regarding eerie, I tried out green colours like many Horror games and media settle on in a Lovecraftian manner, but decided to try making it eerie without the usage of an unnatural green colour. Instead I used fog on top of the pool and indirect lighting.`,
      images: Images12,
  },
    {
      id: 13,
      thumbnail: thumbnails[12],
      title: 'Stücki',
      description: '1/8/2023',
      details: `The mall close to where I live, offered me 50GB of architectural plans, out of which i used one floor plan, to correctly set my scene. I decided to place the camera in the entry area and not build too much around it. `,
      images: Images13,
    },
    {
      id: 14,
      thumbnail: thumbnails[13],
      title: 'Building Process Stücki',
      description: '1/8/2023',
      details: `To help me create the rough outsketch of the mall, I used 3D maps provided by Geocat.ch. I still had to rebuild the whole Building because the mesh was not 
      concipated for a render, but had a good overview towards sizes of the building. The hallway of the mall has very prominent knockoffs of Herzog & Demeuron sperm lamps, which I always wanted to rebuild in 3D.`,
      images: Images14,
    },
    {
      id: 15,
      thumbnail: thumbnails[14],
      title: 'Final Experiments Stücki',
      description: '6/8/2023',
      details: `
      I used distortion of the truth and had the sale windows repeat much further than in reality. I really liked the realistic natural colours of the scene but
      when playing around with green colour again, I wondered if it was possible to create a neutral liminal feeling with a rather disney evil green.
      Finally I could also use a Flash properly to light the scene and give it a photographic appeal, which i couldnt in other scenes because of the fog.
      As Eerie I chose the colour red, which is very unsettling without knowing where the colour emanates from. For Kitsch I integrated Ocean like waves in glass to 
      the ceiling, to subsitute the wave form there usually is.`,
      images: Images15,
    },
    {
      id: 16,
      thumbnail: thumbnails[15],
      title: 'Side Alley',
      description: '13/8/2023',
    details: `
    The Side Alley is a long building close to where I live, which always caught my eye when passing it. I wanted to try and recreate the liminal
    feeling it triggered with me. I used two reference photographs shot on my phone, a google Maps satellite screenshot and a 3D map by Geocat.ch again.`,
    images: Images16
  },
    {
      id: 17,
      thumbnail: thumbnails[16],
      title: 'Building Process Side Alley',
      description: '13/8/2023',
      details: `
      The building has many repetetive traits like windows, balconies, light fixtures, ladders, window shutters, etc.
      Since i chose a perspective in the beginning, that was not showing the whole building, I did most things only in the first 
      half of the building.
      I also added some trees in the middle of the map. And ignored the parking cars from the original place. I love working on small details, 
      so the railings of the balconies added extra realism.`,
      images: Images17,
    },
    {
      id: 18,
      thumbnail: thumbnails[17],
      title: 'Final Experiments Side Alley',
      description: '16/8/2023',
      details: `With these final images I wanted to include rain, which took me a while to figure out - the scene was made with 6000000 rain particles. I also wanted to try out 
      a more dreamlike scene with a starry sky. In the other render I distorted reality by prolonging the building by ten times, which makes it seem infinite.
      I also envisioned something more grimy and used ambient occlusion on the objects with a very crass fark shadow.`,
      images: Images18,
    },
    {
      id: 19,
      thumbnail: thumbnails[18],
      title: 'Final Pictures',
      description: '23/8/2023',
      details: `
      These are my final pictures, three per scene. One should be normal liminal, the other Kitsch liminal, the other eerie liminal.`,
      images: Images19,
    },
  ];
  
  // Continue adding more cards


  function Card({ card, onClick }) {
    return (
      <div className="card" onClick={() => onClick(card.id)}>
        <img src={card.thumbnail} alt={`Thumbnail for ${card.title}`} />
        <h2>{card.title}</h2>
        <h4>{card.description}</h4>
      </div>
    );
  }
  
  function App() {
    const [selectedCard, setSelectedCard] = useState(null);
    const [contentLoaded, setContentLoaded] = useState(false);
  
    useEffect(() => {
      setTimeout(() => {
        setContentLoaded(true);
      }, 60000);
  
      return () => {
        // Cleanup if needed
      };
    }, []);
  
    const showDetails = (cardId) => {
      setSelectedCard(cardsData.find((card) => card.id === cardId));
    };
  
    const closeDetailsModal = () => {
      setSelectedCard(null);
    };
  
    const handleResetOpacity = () => {
      document.body.classList.add('reset-opacity');
      setTimeout(() => {
        document.body.classList.remove('reset-opacity');
      }, 100);
    };
  
    return (
      <div className={`App ${contentLoaded ? 'loaded' : ''}`}>
        <h1>We Got Liminal Spaces At Home Process Documentation</h1>
        <h3>by Anna Dippert</h3>
        <div className="card-container">
          {cardsData.map((card) => (
            <Card key={card.id} card={card} onClick={showDetails} />
          ))}
        </div>
  
        {selectedCard && (
          <div className="modal">
            <span className="close" onClick={closeDetailsModal}>
              &times;
            </span>
            <div className="modal-content">
              <h2>{selectedCard.title}</h2>
              <p>{selectedCard.details}</p>
              <div className="image-gallery">
                {selectedCard.images.map((imageSrc, index) => (
                  <img
                    key={index}
                    src={imageSrc}
                    alt={`Image ${index + 1}`}
                    className="gallery-image"
                  />
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
  
  export default App;
  
  
  
  
  
  
  